/*
 *  Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 *  Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { createAction } from '../../../utils/redux-utils';
import { CashBoxesStats } from '../../api/cashBoxes/cashBoxesClient.typings';
import { Notification } from '../../../utils/utils';
import { CompanyDetailsDto } from '../../api/companies/companiesClient.typings';

export enum TaxpayerAccDetailsActionType {
    OPEN_TAXPAYER_ACC_HOME_PAGE = 'Taxpayer acc home/ open page',
    EXIT_TAXPAYER_ACC_HOME_PAGE = 'Taxpayer acc home/ exit page',

    FETCH_TAXPAYER_ACC_DETAILS_SUCCESS = 'Taxpayer acc home/ fetch taxpayer details success',
    FETCH_TAXPAYER_ACC_CASHBOXES_STATS_SUCCESS = 'Taxpayer acc home/ fetch taxpayer cashboxes stats success',

    FETCH_TAXPAYER_ACC_HOME_DATA_ERROR = 'Taxpayer acc details/ fetch taxpayer home data error',
}

export const openTaxpayerAccHomePageAction = () =>
    createAction(TaxpayerAccDetailsActionType.OPEN_TAXPAYER_ACC_HOME_PAGE);

export const exitTaxpayerAccHomePageAction = () =>
    createAction(TaxpayerAccDetailsActionType.EXIT_TAXPAYER_ACC_HOME_PAGE);

export const fetchTaxpayerAccDetailsSuccessAction = (payload: CompanyDetailsDto) =>
    createAction(TaxpayerAccDetailsActionType.FETCH_TAXPAYER_ACC_DETAILS_SUCCESS, payload);

export const fetchTaxpayerAccCashboxesStatsSuccessAction = (payload: CashBoxesStats) =>
    createAction(TaxpayerAccDetailsActionType.FETCH_TAXPAYER_ACC_CASHBOXES_STATS_SUCCESS, payload);

export const fetchTaxpayerAccHomeDataErrorAction = (notification: Notification) =>
    createAction(TaxpayerAccDetailsActionType.FETCH_TAXPAYER_ACC_HOME_DATA_ERROR, { notification });

export type TaxpayerAccDetailsActions =
    | ReturnType<typeof openTaxpayerAccHomePageAction>
    | ReturnType<typeof exitTaxpayerAccHomePageAction>
    | ReturnType<typeof fetchTaxpayerAccDetailsSuccessAction>
    | ReturnType<typeof fetchTaxpayerAccCashboxesStatsSuccessAction>
    | ReturnType<typeof fetchTaxpayerAccHomeDataErrorAction>;
